// Settings card: every service / characteristic the connected PM5 offers.
import { useEffect, useState } from 'react';
import { Bluetooth, Download, RefreshCw } from 'lucide-react';
import { toast } from 'sonner';
import { listPm5Gatt } from '@/lib/pm5ForceCurve';

const short = (uuid) => (uuid?.startsWith('ce06') ? `CE06${uuid.slice(4, 8).toUpperCase()}` : uuid);

export const Pm5GattCard = () => {
  const [gatt, setGatt] = useState(() => window.__crewzPm5Gatt || null);

  useEffect(() => {
    const on = (e) => setGatt(e.detail);
    window.addEventListener('crewz-pm5-gatt', on);
    return () => window.removeEventListener('crewz-pm5-gatt', on);
  }, []);

  const refresh = async () => {
    if (!window.pm5Connection?.isConnected) { toast.error('Connect the PM5 first'); return; }
    await listPm5Gatt(window.pm5Connection);
  };
  const download = () => {
    const blob = new Blob([JSON.stringify(gatt, null, 2)], { type: 'application/json' });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = `crewz-pm5-services-${gatt.at.slice(0, 19).replace(/[:T]/g, '')}.json`;
    document.body.appendChild(a); a.click(); a.remove();
  };

  return (
    <div className="bg-white dark:bg-zinc-800 border border-zinc-200 dark:border-zinc-700 rounded-lg px-4 py-3" data-testid="pm5-gatt-card">
      <div className="flex items-center gap-2 mb-2">
        <Bluetooth className="w-4 h-4 text-zinc-500" />
        <span className="text-sm font-medium text-zinc-700 dark:text-zinc-300">PM5 services &amp; characteristics</span>
        <span className="ml-auto flex gap-2">
          <button type="button" onClick={refresh} className="px-2 py-1 text-xs font-bold rounded-md border border-zinc-300 flex items-center gap-1" data-testid="pm5-gatt-refresh"><RefreshCw className="w-3 h-3" /> List</button>
          {gatt && <button type="button" onClick={download} className="px-2 py-1 text-xs font-bold rounded-md bg-zinc-900 text-white flex items-center gap-1" data-testid="pm5-gatt-download"><Download className="w-3 h-3" /> Download</button>}
        </span>
      </div>
      {!gatt ? (
        <p className="text-xs text-zinc-400">Listed automatically when the PM5 connects.</p>
      ) : (
        <div className="text-[11px] font-mono text-zinc-600 dark:text-zinc-300 space-y-1 max-h-64 overflow-auto" data-testid="pm5-gatt-list">
          {gatt.services.map((s, i) => (
            <div key={s.service || i}>
              <div className="font-bold">{s.error ? `Error: ${s.error}` : `Service ${short(s.service)}`}</div>
              {(s.characteristics || []).map((c, j) => (
                <div key={c.uuid || j} className="pl-3">
                  {c.error ? `Error: ${c.error}` : `${short(c.uuid)} ${[c.notify && 'notify', c.read && 'read', c.write && 'write'].filter(Boolean).join(' ')}`}
                </div>
              ))}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
